import { SharedStore } from '@squareup/dex-shell-main-shared';
import { useStore } from 'react-redux';

export const useSharedStore: () => SharedStore = useStore;
